// extracted by mini-css-extract-plugin
export default {"ns_message":"TicketViewPage_ns_message__h75ep"};